import { AttachmentsField } from "@/components/AttachmentsField";
import { taskAttachmentsApi } from "@/lib/api";

export function TaskAttachments({ taskId, onIdsChange }) {
  return (
    <AttachmentsField
      ownerId={taskId}
      api={taskAttachmentsApi}
      onIdsChange={onIdsChange}
      testidPrefix="task-attachment"
    />
  );
}
